import React, { FormEvent, ReactNode, useContext, useEffect, useState } from 'react';
import ModalContainer from "../_common/_Modal_layout";
import Btn from "../_custom/button";
import { FormRow } from '../_custom/form_row';
import { DialogSetContext } from "../../apps/_root";
import swal from "sweetalert";
import { BANK_CHOICES } from '../../type/user';
import api from '../../util/api';


function RegisterModal({ registerShow, setRegisterShow }:
    { registerShow: boolean; setRegisterShow: Function }) {
    const [errors, setErrors] = useState<any>()

    function handleSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()

        const formData = new FormData(e.currentTarget)
        api('/api/user/signup', { method: "POST", body: formData })
            .then(res => swal({
                text: '회원가입 신청이 완료되었습니다.',
                icon: 'success'
            }))
            .catch((error: Response) => handleAPIError(error))
    }
    async function handleAPIError(res: Response) {
        const err: any = await res.json();
        if (typeof err == 'string') {
            swal({ text: err, icon: 'error' })
        } else {
            setErrors(err)
            // swal({ text: "오류가 발생했습니다.", icon: 'error' })
        }
    }
    useEffect(() => {
        if (!registerShow) setErrors(undefined);
    }, [registerShow])
    return (
        <ModalContainer show={registerShow}
            setShow={setRegisterShow}
            className={'register-pop'}
            title={'회원가입'}
        >
            <main>
                <div className={'inner-layout'}>
                    <header>
                        <div className={'header-bg'}></div>
                        <p>Welcome to <b>RICHARD MILLE CASINO</b></p>
                    </header>
                    <form onSubmit={handleSubmit} >
                        <div className={'form-inner'}>
                            <FormRow>
                                <FormRow.Name>아이디 <b>*</b></FormRow.Name>
                                <FormRow.Input type="text"
                                    name={'username'}
                                    placeholder={`6자이상 영문, 숫자만 가능`}
                                    error={errors?.username && errors.username}
                                />
                            </FormRow>
                            <FormRow>
                                <FormRow.Name>전화번호 <b>*</b></FormRow.Name>
                                <FormRow.Input type="text"
                                    name={'phone'}
                                    placeholder={`'_'없이 숫자 만 입력`}
                                    error={errors?.phone && errors.phone}
                                />
                            </FormRow>
                            <FormRow>
                                <FormRow.Name>닉네임 <b>*</b></FormRow.Name>
                                <FormRow.Input type="text"
                                    name={'nickname'}
                                    placeholder={`2자이상 한글,영문 및 숫자 가능`}
                                    error={errors?.nickname && errors.nickname}
                                />
                            </FormRow>
                            <FormRow>
                                <FormRow.Name>추천인 <b>*</b></FormRow.Name>
                                <FormRow.Input type="text"
                                    name={'recommendation_code'}
                                    placeholder={`매장명 기재`}
                                    error={errors?.recommendation_code && errors.recommendation_code}
                                />
                            </FormRow>
                            <FormRow>
                                <FormRow.Name>비밀번호 <b>*</b></FormRow.Name>
                                <FormRow.Input type="password"
                                    name={'password'}
                                    placeholder={``}
                                    error={errors?.password && errors.password}
                                />
                            </FormRow>
                            <FormRow>
                                <FormRow.Name>비밀번호 확인 <b>*</b></FormRow.Name>
                                <FormRow.Input type="password"
                                    name={'password_confirm'}
                                    placeholder={``}
                                    error={errors?.password_confirm && errors.password_confirm}
                                />
                            </FormRow>
                            <FormRow>
                                <FormRow.Name>은행명</FormRow.Name>
                                <select name="bank_name" >
                                    <option value={''}>선택하세요.</option>
                                    {
                                        BANK_CHOICES.map(([code, label]) => (
                                            <option key={code} value={code}>{label}</option>
                                        ))
                                    }
                                </select>
                            </FormRow>
                            <FormRow>
                                <FormRow.Name>계좌번호</FormRow.Name>
                                <FormRow.Input type="text"
                                    name={'bank_number'}
                                    placeholder={`'_'없이 숫자 만 입력`} />
                            </FormRow>
                            <FormRow>
                                <FormRow.Name>예금주</FormRow.Name>
                                <FormRow.Input type="text"
                                    name={'bank_owner'}
                                    placeholder={`2자이상 한글, 영문만 가능(예금주는 수정불가/고객센터문의)`} />
                            </FormRow>
                        </div>

                        <div className={'btn-area'}>
                            <Btn color={'yellow'} type='submit' >회원가입</Btn>
                            <Btn color={'gray'} type='button' onClick={e => setRegisterShow(false)}>취소</Btn>
                        </div>
                    </form>
                </div>
            </main>
        </ModalContainer>
    );
}

export default RegisterModal;